export const IDCOMODIN = 52;
export const TOTAL_CLASES_TIPO1 = 11;
export const PUNTUACION_COMODIN = 5;